var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"block-cars"},_vm._l((_vm.cars),function(car){return _c('Car',{key:car.id,attrs:{"data":car},on:{"getCall":() => _vm.getCall('sale'),"getFullSlider":(data) => _vm.getFullSlider(data)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }